import { render, staticRenderFns } from "./oa_export_percent.vue?vue&type=template&id=24a03d64&"
import script from "./oa_export_percent.vue?vue&type=script&lang=js&"
export * from "./oa_export_percent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports